var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pc-page-my-journey-measument-chart-box-skeleton"},[_c('div',{staticClass:"container"},[_c('AnimatedPlaceholder',{attrs:{"width":"100%","height":"400px","border-radius":"0"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }